// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IPlanPropertyChangeDto
 */
export interface IPlanPropertyChangeDto {
    /**
     * 
     * @type {string}
     * @memberof IPlanPropertyChangeDto
     */
    property_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IPlanPropertyChangeDto
     */
    display_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IPlanPropertyChangeDto
     */
    old_value?: string;
    /**
     * 
     * @type {string}
     * @memberof IPlanPropertyChangeDto
     */
    new_value?: string;
    /**
     * 
     * @type {string}
     * @memberof IPlanPropertyChangeDto
     */
    old_property_type?: string;
    /**
     * 
     * @type {string}
     * @memberof IPlanPropertyChangeDto
     */
    new_property_type?: string;
    /**
     * 
     * @type {string}
     * @memberof IPlanPropertyChangeDto
     */
    old_field_state?: IPlanPropertyChangeDtoOldFieldStateEnum;
    /**
     * 
     * @type {string}
     * @memberof IPlanPropertyChangeDto
     */
    new_field_state?: IPlanPropertyChangeDtoNewFieldStateEnum;
    /**
     * 
     * @type {string}
     * @memberof IPlanPropertyChangeDto
     */
    group_type?: IPlanPropertyChangeDtoGroupTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IPlanPropertyChangeDto
     */
    group_label?: string;
}

/**
* @export
* @enum {string}
*/
export enum IPlanPropertyChangeDtoOldFieldStateEnum {
    MODIFIABLE = 'MODIFIABLE',
    LOCKED = 'LOCKED',
    HIDDEN = 'HIDDEN',
    REQUIRED_AT_PLAN = 'REQUIRED_AT_PLAN',
    REQUIRED_AT_ALL_LEVELS = 'REQUIRED_AT_ALL_LEVELS'
}
/**
* @export
* @enum {string}
*/
export enum IPlanPropertyChangeDtoNewFieldStateEnum {
    MODIFIABLE = 'MODIFIABLE',
    LOCKED = 'LOCKED',
    HIDDEN = 'HIDDEN',
    REQUIRED_AT_PLAN = 'REQUIRED_AT_PLAN',
    REQUIRED_AT_ALL_LEVELS = 'REQUIRED_AT_ALL_LEVELS'
}
/**
* @export
* @enum {string}
*/
export enum IPlanPropertyChangeDtoGroupTypeEnum {
    NONE = 'NONE',
    CIP = 'CIP',
    INVESTMENTS = 'INVESTMENTS',
    SPEND_LIMIT = 'SPEND_LIMIT',
    PERSON_SPEND_LIMIT = 'PERSON_SPEND_LIMIT',
    CATEGORY_SPEND_LIMIT = 'CATEGORY_SPEND_LIMIT',
    PLAN_LEVEL_FUNDING = 'PLAN_LEVEL_FUNDING',
    PREFUND = 'PREFUND',
    PAYROLL_CONTRIBUTIONS = 'PAYROLL_CONTRIBUTIONS',
    FEE = 'FEE',
    FORFEIT = 'FORFEIT',
    EOY_RECONCILIATION = 'EOY_RECONCILIATION',
    REPLENISHMENT = 'REPLENISHMENT',
    ROLLOVER = 'ROLLOVER'
}


/**
 * Check if a given object implements the IPlanPropertyChangeDto interface.
 */
export function instanceOfIPlanPropertyChangeDto(value: object): value is IPlanPropertyChangeDto {
    return true;
}

export function IPlanPropertyChangeDtoFromJSON(json: any): IPlanPropertyChangeDto {
    return IPlanPropertyChangeDtoFromJSONTyped(json, false);
}

export function IPlanPropertyChangeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPlanPropertyChangeDto {
    if (json == null) {
        return json;
    }
    return {
        
        'property_name': json['property_name'] == null ? undefined : json['property_name'],
        'display_name': json['display_name'] == null ? undefined : json['display_name'],
        'old_value': json['old_value'] == null ? undefined : json['old_value'],
        'new_value': json['new_value'] == null ? undefined : json['new_value'],
        'old_property_type': json['old_property_type'] == null ? undefined : json['old_property_type'],
        'new_property_type': json['new_property_type'] == null ? undefined : json['new_property_type'],
        'old_field_state': json['old_field_state'] == null ? undefined : json['old_field_state'],
        'new_field_state': json['new_field_state'] == null ? undefined : json['new_field_state'],
        'group_type': json['group_type'] == null ? undefined : json['group_type'],
        'group_label': json['group_label'] == null ? undefined : json['group_label'],
    };
}

export function IPlanPropertyChangeDtoToJSON(json: any): IPlanPropertyChangeDto {
    return IPlanPropertyChangeDtoToJSONTyped(json, false);
}

export function IPlanPropertyChangeDtoToJSONTyped(value?: IPlanPropertyChangeDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'property_name': value['property_name'],
        'display_name': value['display_name'],
        'old_value': value['old_value'],
        'new_value': value['new_value'],
        'old_property_type': value['old_property_type'],
        'new_property_type': value['new_property_type'],
        'old_field_state': value['old_field_state'],
        'new_field_state': value['new_field_state'],
        'group_type': value['group_type'],
        'group_label': value['group_label'],
    };
}

